import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useCloneStrategyMemoMutation } from '../hooks/useCloneStrategyMemoMutation'
import {
  type StrategyMemo,
  useInvalidateStrategyMemosInfiniteQuery,
} from '../hooks/useStrategyMemosInfiniteQuery'

export type CloneButtonProps = {
  strategyMemo: StrategyMemo
}

export const CloneButton = ({ strategyMemo }: CloneButtonProps) => {
  const { t } = useTranslation()
  const invalidateStrategyMemosInfiniteQuery =
    useInvalidateStrategyMemosInfiniteQuery()
  const logEvent = useLogEvent()
  const cloneStrategyMemoMutation = useCloneStrategyMemoMutation({
    onSuccess: () => {
      invalidateStrategyMemosInfiniteQuery()
      logEvent('Copy customer strategy')
    },
  })
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    cloneStrategyMemoMutation.mutate(strategyMemo.id)
  }, [cloneStrategyMemoMutation, strategyMemo.id])

  return (
    <StyledButton
      disabled={cloneStrategyMemoMutation.isPending}
      fillMode="outline"
      icon="copy"
      onClick={handleClick}
    >
      {t('duplicate_1')}
    </StyledButton>
  )
}
